import { render, staticRenderFns } from "./allocation.vue?vue&type=template&id=217a1b09&scoped=true"
import script from "./allocation.vue?vue&type=script&lang=js"
export * from "./allocation.vue?vue&type=script&lang=js"
import style0 from "./allocation.vue?vue&type=style&index=0&id=217a1b09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217a1b09",
  null
  
)

export default component.exports